import { EModel } from '@lumahealthhq/ui-model-types';
import { getModelBasePath } from '@lumahealthhq/ui-utils';
import { useUpdateOne } from '../crud';
var basePath = getModelBasePath(EModel.Campaign);
function makeUpdateOne() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v2/{basePath}/{id}';
  return function (options) {
    return useUpdateOne(variant, basePath, options);
  };
}

/* Default mutations */
export var useCampaignUpdateOne = makeUpdateOne();